export var VELT_SDK_VERSION = '5.0.2-beta.33';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
export var INTEGRITY_MAP = {
    '5.0.2-beta.33': 'sha384-Bpzld7MuVVmBZR+Ptwex4stSbbtH/IPk8TJv+SZwCePZ5NeX0bkW30er/arxexEl',
};
